
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const CHANGE_MENU_PANEL = 'CHANGE_MENU_PANEL';
export const DO_NON_USER_WITH_ERROR_PIN = 'DO_NON_USER_WITH_ERROR_PIN';
export const SHOW_POPUP_IN_MENU = 'SHOW_POPUP_IN_MENU';

export function showPopupInMenu(visible) {
    return {
        type: SHOW_POPUP_IN_MENU,
        payload: visible
    }
}

export function doNonUserWithPinError() {
    return {
        type: DO_NON_USER_WITH_ERROR_PIN
    }
}

export function openMenu() {
    return {
        type: OPEN_MENU
    }
}

export function closeMenu() {
    return {
        type: CLOSE_MENU
    }
}

export function changeMenuPanel(panel) {
    return {
        type: CHANGE_MENU_PANEL,
        payload: {panel}
    }
}



// WEBPACK FOOTER //
// ./src/common/menu/actions.js